import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const BlogManager = {
  // Admin operations
  getAllBlogs: async () => {
    try {
      const response = await axiosInstance.get(`/blogs/all`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching blogs:", error);
      throw error;
    }
  },

  createBlog: async (blogData, imageFile) => {
    try {
      const formData = new FormData();
      formData.append("blog", JSON.stringify(blogData));
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const response = await axiosInstance.post(`/blogs/create`, formData);
      return response.data.responseData;
    } catch (error) {
      console.error("Error creating blog:", error);
      throw error;
    }
  },

  updateBlog: async (blogId, blogData, imageFile) => {
    try {
      const formData = new FormData();
      formData.append("blog", JSON.stringify(blogData));
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const response = await axiosInstance.put(
        `/blogs/update/${blogId}`,
        formData
      );
      return response.data.responseData;
    } catch (error) {
      console.error("Error updating blog:", error);
      throw error;
    }
  },

  deleteBlog: async (blogId) => {
    try {
      const response = await axiosInstance.delete(`/blogs/delete/${blogId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error deleting blog:", error);
      throw error;
    }
  },

  // Public operations
  getActiveBlogs: async () => {
    try {
      const response = await axios.get(`${config.url}/api/blogs/active`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching active blogs:", error);
      throw error;
    }
  },

  getBlogById: async (blogId) => {
    try {
      const response = await axios.get(`${config.url}/api/blogs/${blogId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching blog:", error);
      throw error;
    }
  },
};

export default BlogManager;
